export default __webpack_public_path__ + "static/media/magento2.d2029263.svg";